import axios from "../../index";
import { jobPostUrl } from "../../utils";

export const repostJobPost = async (jobPostId: string) => {
  return await axios.patch(`${jobPostUrl(jobPostId)}/repost`);
};
